import { findIndex, size } from 'lodash/fp';

export const isFirstElement = (predicate, data) => {
  const index = findIndex(predicate, data);

  return index === 0;
};

export const isLastElement = (predicate, data) => {
  const index = findIndex(predicate, data);

  return index === size(data) - 1;
};
